import { render, staticRenderFns } from "./talentItem.vue?vue&type=template&id=708ea922&scoped=true"
import script from "./talentItem.vue?vue&type=script&lang=js"
export * from "./talentItem.vue?vue&type=script&lang=js"
import style0 from "./talentItem.vue?vue&type=style&index=0&id=708ea922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708ea922",
  null
  
)

export default component.exports